import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getTransaction, getWalletBalance } from "../services/utils";
import Navbar from "../components/Navbar";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Wallet = () => {
    let { walletAddress } = useParams();
    const [transactions, setTransactions] = useState([]);
    const [balance, setBalance] = useState([]);

    useEffect(() => {
        const fetchTx = async () => {
            try {
                if (walletAddress) {
                    const txData = await getTransaction(walletAddress);
                    setTransactions(txData?.transfers);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const fetchBalance = async () => {
            try {
                if (walletAddress) {
                    const balanceData = await getWalletBalance(walletAddress);
                    setBalance(balanceData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchTx();
        fetchBalance();
    }, [walletAddress]);

    return (
        <>
            <div className="h-screen">
                <Navbar />
                {/* <HeroSection /> */}
                <>
                    <div className="flex flex-col gap-10 mt-10">
                        <div className="mx-auto mt-10 flex flex-col gap-5">
                            <h1 className="text-center text-3xl font-bold">
                                Detail for Address
                            </h1>
                            <div>
                                <p className="text-center text-lg">
                                    Searched Wallet:{" "}
                                    <b>
                                        <i>{walletAddress}</i>
                                    </b>
                                </p>
                                <p className="text-lg flex items-center justify-center">
                                    Balance:{" "}
                                    {balance.length === 0 ? (
                                        <>
                                            <Skeleton count={1} width={100} />
                                            <span className="ml-1">ETH</span>
                                        </>
                                    ) : (
                                        <>
                                            {parseInt(balance._hex, 16) / 1e18}
                                            <span className="ml-1">ETH</span>
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                        {transactions.length == 0 ? (
                            <div className="w-[90%] mx-auto">
                                <Skeleton count={20} />
                            </div>
                        ) : (
                            <div className="mx-auto">
                                <div className="border border-black rounded-lg overflow-hidden">
                                    <table className="table w-full">
                                        <thead className="bg-gray-200">
                                            <tr className="text-center">
                                                <th className="px-2 py-2">
                                                    Block Number
                                                </th>
                                                <th className="px-2 py-2">
                                                    Hash
                                                </th>
                                                <th className="px-2 py-2">
                                                    From
                                                </th>
                                                <th className="px-2 py-2">
                                                    To
                                                </th>
                                                <th className="px-2 py-2">
                                                    Value (ETH)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions.map(
                                                (transaction, index) => (
                                                    <tr key={index}>
                                                        <td className="p-4">
                                                            <Link
                                                                to={`/block/${parseInt(
                                                                    transaction.blockNum,
                                                                    16
                                                                )}`}
                                                            >
                                                                {parseInt(
                                                                    transaction.blockNum,
                                                                    16
                                                                )}
                                                            </Link>
                                                        </td>
                                                        <td className="p-4 text-left hover:text-blue-500 hover:underline">
                                                            <Link
                                                                to={`/tx/${transaction.hash}`}
                                                            >
                                                                {
                                                                    transaction.hash
                                                                }
                                                            </Link>
                                                        </td>
                                                        <td className="p-4 text-left hover:text-blue-500 hover:underline">
                                                            <Link
                                                                to={`/wallet/${transaction.from}`}
                                                            >
                                                                {
                                                                    transaction.from
                                                                }
                                                            </Link>
                                                        </td>
                                                        <td className="p-4 text-left hover:text-blue-500 hover:underline">
                                                            <Link
                                                                to={`/wallet/${transaction.from}`}
                                                            >
                                                                {transaction.to}
                                                            </Link>
                                                        </td>
                                                        <td className="p-4 text-left">
                                                            {transaction.value}
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            </div>
        </>
    );
};

export default Wallet;
